/* eslint-disable consistent-return */
import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
// import ReactDataGrid from "react-data-grid";
// import "react-data-grid/dist/react-data-grid.css";
import { Table, Badge, Spinner } from "reactstrap";
import PropTypes from "prop-types";

// When Calling this component...must pass the <td>(cells) as children

export default class DataPaginationTable extends PureComponent {
  static propTypes = {
    heads: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
        editable: PropTypes.bool,
        sortable: PropTypes.bool
      })
    ).isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape()).isRequired
    // onSorting: PropTypes.func.isRequired
  };

  state = {
    loading: false,
    prevY: 0,
    moreDataAvailable: true
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.moreDataAvailable !== prevProps.moreDataAvailable) {
      if (this.props.moreDataAvailable === false)
        this.setState({
          moreDataAvailable: this.props.moreDataAvailable,
          loading: false
        });
    }
  }

  componentDidMount() {
    // Working of infinite Scroll
    var options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0
    };

    // It observes the referenced element
    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    this.observer.observe(this.loadingRef);
  }

  // Handling On observe scroll
  handleObserver(entities, observer) {
    const y = entities[0].boundingClientRect.y;
    console.log("if k upper", this.state.prevY, this.state.moreDataAvailable);

    // It runs when there is more data in db
    if (this.props.moreDataAvailable) {
      // When the window comes to the referenced element
      if (this.state.prevY > y && this.props.callMoreData) {
        console.log("if k andar", this.state.prevY);
        this.setState({ loading: true });

        // console.log({ search: this.state.searchKeyword });
        this.props.callMoreData();

        // this.setState({ page: this.state.page + 1 });
      }
    }
    this.setState({ prevY: y });
  }

  rowGetter = i => {
    const { rows } = this.props;
    return rows[i];
  };

  onRowClickHandler = id => {
    console.log("interior-----", id);
    this.props.onRowClickHandler && this.props.onRowClickHandler(id);
  };

  render() {
    const { heads, rows, path } = this.props;
    console.log({ props: this.props.moreDataAvailable });

    const loadingCSS = {
      height: "50px",
      margin: "50px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };

    const loadingTextCSS = {
      display: this.state.loading ? "block" : "none"
    };

    return (
      <div className="table">
        <Table responsive hover bordered>
          <thead>
            <tr>
              {heads.map(header => (
                <th key={header.key} style={{ textAlign: "center" }}>
                  {header.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(data => {
              const row = Object.entries(data).slice(1);
              return (
                <tr
                  key={data.id}
                  onClick={() => this.onRowClickHandler(data.id)}
                  style={{ cursor: "pointer" }}
                >
                  {/* {this.props.children} */}
                  <th scope="row" style={{ textAlign: "center" }}>
                    {data.sno}
                  </th>
                  {row?.map(cell => {
                    if (cell[0] === "status")
                      return (
                        <td key={cell[1]} style={{ textAlign: "center" }}>
                          <h4>
                            <Badge
                              color={
                                cell[1] === "active" || cell[1] === "published"
                                  ? "success"
                                  : cell[1] === "pending"
                                  ? "warning"
                                  : "primary"
                              }
                            >
                              {" "}
                              {cell[1]}{" "}
                            </Badge>{" "}
                          </h4>
                        </td>
                      );
                    return (
                      <td key={cell[1]} style={{ textAlign: "center" }}>
                        {cell[1]}
                      </td>
                    );
                  })}

                  {path && (
                    <td style={{ textAlign: "center" }}>
                      <Link
                        to={`/${path}/${data.id}`}
                        style={{ textDecoration: "none" }}
                      >
                        {" "}
                        View{" "}
                      </Link>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
        <div
          ref={loadingRef => (this.loadingRef = loadingRef)}
          style={loadingCSS}
        >
          <span style={loadingTextCSS}>
            <Spinner size="small" />
          </span>
        </div>
      </div>
    );
  }
}
